/* ============================================================
   GYAANSTORE — WISHLIST MODULE (single source of truth)
   File: assets/gs-wishlist.js   ·  load ONCE in theme.liquid (defer)

   Owns ALL wishlist behaviour for: product cards, product page,
   wishlist page, and the header count. Replaces the per-card
   inline script that previously shipped once per product card.

   Storage: localStorage key "shopify_wishlist" (array of items).
   Events:  fires "wishlist-updated" (same page) on every change.
            cross-tab sync via the native "storage" event.
   ============================================================ */
/* Run-once guard keyed on our OWN flag (__gsWishlistModuleLoaded), NOT on
   "is window.toggleSlickWishlist still undefined?".
   WHY: some sections (e.g. sections/related-products.liquid) used to inline
   their own HEADER-LESS copy of toggleSlickWishlist/syncSlickWishlistButtons
   during page parse. Because that inline copy ran first, the old guard
   ("typeof toggleSlickWishlist === 'undefined'") saw the name already taken
   and SKIPPED this whole module — so on product pages the header wishlist
   count never updated. This flag can only ever be set by THIS file, so inline
   duplicates can no longer shadow the canonical, header-aware module, while we
   still avoid double-binding listeners if the file is somehow loaded twice. */
if (!window.__gsWishlistModuleLoaded) {
  window.__gsWishlistModuleLoaded = true;

  /* unique key per product+variant */
  window._slickWlKey = function (pid, vid) {
    return String(pid) + ':' + String(vid || pid);
  };

  /* normalize + de-dupe the saved list */
  window._slickNormalizeWishlist = function (list) {
    var seen = {}, clean = [];
    if (!Array.isArray(list)) return clean;
    list.forEach(function (item) {
      if (!item || !item.id) return;
      var n = {
        id: String(item.id),
        handle: item.handle || '',
        variantId: String(item.variantId || item.id),
        variantTitle: item.variantTitle || '',
        title: item.title || 'Product',
        image: item.image || '',
        url: item.url || '#',
        price: item.price || '',
        author: item.author || '',
        vendor: item.vendor || '',
        priceRaw: item.priceRaw || '',
        compareAtPrice: item.compareAtPrice || '',
        compareAtPriceRaw: item.compareAtPriceRaw || '',
        discountPct: item.discountPct || '',
        available: item.available !== false && item.available !== 'false',
        savedAt: item.savedAt || Date.now()
      };
      var key = window._slickWlKey(n.id, n.variantId);
      if (!seen[key]) { seen[key] = true; clean.push(n); }
    });
    return clean;
  };

  function readList() {
    var list = [];
    try { list = JSON.parse(localStorage.getItem('shopify_wishlist') || '[]'); } catch (e) {}
    return window._slickNormalizeWishlist(list);
  }
  function writeList(list) {
    try { localStorage.setItem('shopify_wishlist', JSON.stringify(list)); } catch (e) {}
  }

  /* toggle from a wishlist button's data-* attributes */
  window.toggleSlickWishlist = function (btn, e) {
    if (e) { e.preventDefault(); e.stopPropagation(); }

    var pid = btn.getAttribute('data-product-id');
    var variantId = btn.getAttribute('data-variant-id');
    var list = readList();
    var key = window._slickWlKey(pid, variantId);
    var idx = list.findIndex(function (item) {
      return window._slickWlKey(item.id, item.variantId) === key;
    });

    if (idx === -1) {
      list.push({
        id: pid,
        handle: btn.getAttribute('data-product-handle') || '',
        variantId: variantId,
        variantTitle: btn.getAttribute('data-variant-title') || '',
        title: btn.getAttribute('data-product-title'),
        image: btn.getAttribute('data-product-image'),
        url: btn.getAttribute('data-product-url'),
        price: btn.getAttribute('data-product-price'),
        author: btn.getAttribute('data-product-author') || '',
        vendor: btn.getAttribute('data-product-vendor') || '',
        priceRaw: btn.getAttribute('data-product-price-raw') || '',
        compareAtPrice: btn.getAttribute('data-product-compare-price') || '',
        compareAtPriceRaw: btn.getAttribute('data-product-compare-price-raw') || '',
        discountPct: btn.getAttribute('data-product-discount') || '',
        available: btn.getAttribute('data-product-available') !== 'false',
        savedAt: Date.now()
      });
      btn.classList.add('is-wished');
      btn.setAttribute('aria-label', 'Remove from wishlist');
      btn.setAttribute('aria-pressed', 'true');
    } else {
      list.splice(idx, 1);
      btn.classList.remove('is-wished');
      btn.setAttribute('aria-label', 'Add to wishlist');
      btn.setAttribute('aria-pressed', 'false');
    }

    writeList(list);
    /* notify this page. (Cross-tab handled by the native storage event —
       no synthetic dispatch, which previously double-fired the sync.) */
    document.dispatchEvent(new CustomEvent('wishlist-updated'));
  };

  /* keep every wishlist button + the header count in sync with storage */
  window.syncSlickWishlistButtons = function () {
    var list = readList();
    var keys = list.map(function (item) {
      return window._slickWlKey(item.id, item.variantId);
    });

    document.querySelectorAll('.card__wishlist-btn[data-product-id], [data-gs-wishlist-btn]').forEach(function (btn) {
      var wished = keys.indexOf(window._slickWlKey(
        btn.getAttribute('data-product-id'),
        btn.getAttribute('data-variant-id')
      )) > -1;
      btn.classList.toggle('is-wished', wished);
      btn.setAttribute('aria-label', wished ? 'Remove from wishlist' : 'Add to wishlist');
      btn.setAttribute('aria-pressed', wished ? 'true' : 'false');
    });

    /* header count (single source — replaces the old header inline script) */
    var badge = document.getElementById('wishlist-count-badge');
    var icon = document.querySelector('.header-wishlist-icon');
    var srText = document.getElementById('wishlist-count-text');
    var count = list.length;
    /* CSS hides the badge by default and shows it as flex when populated */
    if (badge) { badge.textContent = count; badge.style.display = count > 0 ? 'flex' : 'none'; }
    if (icon) { icon.classList.toggle('has-items', count > 0); }
    if (srText) { srText.textContent = count > 0 ? ('Wishlist, ' + count + ' items') : 'Wishlist'; }
  };

  /* init + listeners */
  function gsWishlistInit() { window.syncSlickWishlistButtons(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', gsWishlistInit);
  } else {
    gsWishlistInit();
  }
  document.addEventListener('wishlist-updated', window.syncSlickWishlistButtons);
  document.addEventListener('shopify:section:load', window.syncSlickWishlistButtons);
  window.addEventListener('storage', function (e) {
    if (!e.key || e.key === 'shopify_wishlist') window.syncSlickWishlistButtons();
  });
  /* bfcache fix (2026-07-02): the BACK button restores pages from memory with NO
     reload and NO storage event, so hearts/count wished on another page were stale
     until refresh. pageshow fires on every restore (and normal loads - harmless). */
  window.addEventListener('pageshow', window.syncSlickWishlistButtons);
}
